/**
 * GetDeviceInfo
 *
 * Module to detect device type and page orientation.
 * 
 * Device type is based on foundation recommandation http://foundation.zurb.com/docs/media-queries.html  
 *
 * @return {object}
 */

OT.createNS('OT.Common.Helpers.GetDeviceInfo');

OT.Common.Helpers.getDeviceInfo = function (pageSize) {
    'use strict';
    var $navigator = OT.Common.getNavigator();
    var isPortrait = (pageSize.width < pageSize.height);
    var isMobile = OT.Common.Helpers.isMobile($navigator.userAgent).Any();

    var width = isMobile ? pageSize.screenWidth : pageSize.width;
    var height = isMobile ? pageSize.screenHeight : pageSize.height;

    var getDeviceType = function () {

        var maxWidth = (width <= 0 || height <= 0) ? 0 : Math.max(width, height);

        if (maxWidth > 0 && maxWidth < 641) {
            return OT.Common.DeviceType.phone;
        } else if (maxWidth > 640 && maxWidth < 1025) {
            return OT.Common.DeviceType.tablet;
        } else if (maxWidth > 1440 && maxWidth < 1921) {
            return OT.Common.DeviceType.xLarge;
        } else if (maxWidth > 1920) {
            return OT.Common.DeviceType.xXLarge;
        } else {
            return OT.Common.DeviceType.large;
        }
    };

    return {
        deviceType: getDeviceType(),
        isPortrait: isPortrait,
        isMobile: isMobile
    };
};
